import InvokeAnalysisProduct from "./InvokeAnalysisProduct";

function InvokeRetention(props) {
    return(<InvokeAnalysisProduct product="InvokeRetention" />);
}

export default InvokeRetention;